import isServer from '../../helpers/isServer';

export default () => {
  if (isServer()) {
    return false;
  }

  return typeof document.createElement('div').style.grid !== 'string';
};
